import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeadingStructureFaq"] */ "/app/src/components/tools/HeadingStructureFaq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeadingStructureTool"] */ "/app/src/components/tools/HeadingStructureTool.tsx");
